<!--
//================================================================================
// ID:BC057
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC057
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/10/21 | 富士通Japan株式会社    | 新規作成
// 01.01.00 | 2023/08/08 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<div class="contents__main">
		<error-message/>
		<div class="contents__information div-tyuimargin">
			<div class="contents__attention">
				<ul class="text-lineheight">
					<li>
						まだ、住宅は確保されていません。住宅の仮押さえを行うには最下部の「世帯情報代理入力へ」を押下してください。<br />
						※残戸数の表示にはタイムラグがあります。あらかじめご了承ください。
					</li>
				</ul>
			</div>
		</div>
		<h2 class="contents__h2 title-style">募集住宅情報</h2>
		<section>
			<table class="contents__table--stripe detail">
				<tbody>
					<tr>
						<th class="contents__input--title">入居人数</th>
						<td colspan="3" class="contents__input--label">{{ disp.nyukyoSu }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">申込地区番号</th>
						<td colspan="3" class="contents__input--label">{{ disp.noMouchiku }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">住宅名</th>
						<td colspan="3" class="contents__input--label">{{ disp.jyutakuName }}<br /></td>
					</tr>
					<tr>
						<th class="contents__input--title">代表的な所在地</th>
						<td colspan="3" class="contents__input--label">{{ disp.kusicyo }}
							<div v-if="disp.mapLink != ''">
								<a class="contents__btn--map" tabindex="1">
									<font-awesome-icon :icon="['fas', 'map-marker-alt']" class="icon-size" />
									<span class="margin-map_btn" @click="moveMapSite()">地図等の詳細情報へ</span>
								</a><br/>
								<label class="contents__caution">※外部サイトへ遷移します</label>
							</div>
						</td>
					</tr>
					<tr>
						<th class="contents__input--title">主な交通機関</th>
						<td colspan="3" class="contents__input--label">{{ disp.trans }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">残戸数</th>
						<td colspan="3" class="contents__input--label">{{ disp.nuZankosu }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">間取り</th>
						<td class="contents__input--label contents__kaigyo--css">{{ disp.madori }}</td>
						<th class="contents__input--title">専用面積(m&sup2;)</th>
						<td class="contents__input--label">{{ disp.senyoArea }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">建設年度</th>
						<td class="contents__input--label">{{ disp.ymkensetu }}</td>
						<th class="contents__input--title">エレベーター</th>
						<td class="contents__input--label">{{ disp.elevatorUmu }}</td>
					</tr>
					<tr v-if="disp.listHideKbn == 1">
						<th class="contents__input--title">対象階</th>
						<td colspan="3" class="contents__input--label">{{ disp.jikotaisyo }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">使用料(円)</th>
						<td colspan="3" class="contents__input--label">{{ disp.moSiyoryo }}</td>
					</tr>
					<tr>
						<th class="contents__input--title">仕様等</th>
						<td colspan="3" class="contents__input--label">{{ disp.siyouEtc }}</td>
					</tr>
					<tr v-if="disp.listHideKbn == 1">
						<th class="contents__input--title">事故内容</th>
						<td colspan="3" class="contents__input--label">{{ disp.jikonaiyo }}</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<div align="center">
				<p id="pc_text" class="contents__input--label">
					<label>
					申込みには世帯情報の登録が必要です。この住宅に申込む場合は「{{disp.bc058BtnName}}」ボタンをクリックしてください。<br />
					住宅を選びなおす場合は下の「戻る」ボタンをクリックしてください。
					</label>
				</p>
			</div>
			<div class="contents__div--center">
				<input
					type="button"
					value="世帯情報代理入力へ"
					@click="clickInsertBtn"
					class="contents__btn--confirm detail_btn"
					ref="confirmBtn"
					tabindex="2"
				/>
				<input
					type="button"
					value="戻る"
					@click="goBackBtn"
					class="contents__btn--cancel cancel_btn"
					tabindex="3"
				/>
			</div>
		</section>
	</div>
</template>
<script>
import ErrorMessage from '@/components/ErrorMessage.vue';

import { co_post } from '@/common/ajaxUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_confirmDialog, co_completedDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { co_toTop, co_toTrans, co_clearParam} from '@/common/screenUtility.js';

import { DIALOG_BUTTON_LIST_KEY } from '@/const/const.js';
import { PATH_BC057_CHECK } from '@/const/route.js';
import { STORE_VIEW_PROGRESS, STORE_ERROR_SETMSG, STORE_DATA_GETDATA, STORE_ERROR_CLEAR, STORE_DATA_ADD_DATA, STORE_VIEW_GET_PARAMS } from '@/const/store.js';

export default {
	name: "BC057",
	components: {
		'error-message': ErrorMessage,
	},
	data: function () {
		return {
			form: {
			},
			disp: {
				nyukyoSu: '',			// 入居人数
				nuZankosu: '',			// 残戸数
				noMouchiku: '',			// 申込地区番号
				jyutakuName: '',		// 住宅名
				kusicyo: '',			// 代表的な所在地
				trans: '',				// 主な交通機関
				madori: '',				// 間取り
				senyoArea: '',			// 専用面積
				ymkensetu: '',			// 建設年度
				elevatorUmu: '',		// エレベーター
				moSiyoryo: '',			// 使用料
				siyouEtc: '',			// 仕様等
				jikotaisyo: '',			// 対象階
				jikonaiyo: '',			// 事故内容
				jyutakuKind: '',		// 住宅の種別
				nmZyutaku: '',			// 住宅の種別名称
				bosyuKind: '',			// 募集の種類
				nmBosyu: '',			// 募集の種類名称
				ymBosyu: '',			// 募集年月
				zikoUmu: '',			// 居室内で病死等があった住宅の有無
				listHideKbn: 0,         // 一覧非表示区分(1:対象階・事故内容以外、2：全て)
				hanyoCode: '',			// 汎用コード
				bc058BtnName: '',		// 世帯情報代理入力へボタン名称
				noRenzoku: '',			// 連番
				mapLink: '',			// 外部マップサービスのリンク先
			},
			jyutakuInfo: [],			// 住宅情報
			bosyuKind: '',				// 募集の種類
			jyutakuKind: '',			// 住宅の種別
			zikoUmu: '',				// 事故有無
			co_commaSeparated: co_commaSeparated,
		}
	},
	mounted: async function () {
	},
	created: async function() {

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC057');
		this.jyutakuInfo = params.jyutakuInfo;
		this.bosyuKind = params.bosyuKind;
		this.jyutakuKind = params.jyutakuKind;
		this.zikoUmu = params.zikoUmu;

		// 画面間パラメータを削除
		co_clearParam('BC057');
		
		// 世帯情報入力（随時募集・管理者用【代理申込み】）画面から遷移した場合
		if (this.bosyuKind === '') {

			// 状態管理（ストア）から前回情報を取得
			let data = this.$store.getters[STORE_DATA_GETDATA]('BC057');

			if (data === null) {
				// 前回情報が存在しない場合、ログイン画面に遷移
				co_toTrans('BC001');
				return;
			}

			this.disp = data;

		} else {

			// 募集住宅一覧（随時募集・管理者用【代理申込み】）画面から遷移した場合
			let data = this.jyutakuInfo;

			// 入居人数
			this.disp.nyukyoSu = data.nyukyoSu;
			let maxStr = 7;
			if (data.nyukyoSu.length != maxStr){
				for (let i = 0; i < 2; i++){
					this.disp.nyukyoSu = this.disp.nyukyoSu + '\u3000' ;
				}
			}
			this.disp.nuZankosu = data.nuZankosu;
			this.disp.noMouchiku = data.noMouchiku;
			this.disp.jyutakuName = data.jyutakuName;
			this.disp.kusicyo = data.kusicyo;
			this.disp.trans = data.trans;
			this.disp.madori = data.madori;
			this.disp.senyoArea = data.senyoArea;
			// 建設年度
			if (data.kensetuUpr == null || data.kensetuUpr == '') {
				this.disp.ymkensetu = data.kensetuLow;
			} else if (data.kensetuLow == null || data.kensetuLow == '') {
				this.disp.ymkensetu = '';
			} else {
				this.disp.ymkensetu = data.kensetuLow + '～' + data.kensetuUpr;
			}
			// 使用料
			if (data.moSiyoryoUpr == null || data.moSiyoryoLow == '') {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow);
			} else if (data.moSiyoryoLow == null || data.moSiyoryoLow == '') {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow);
			} else {
				this.disp.moSiyoryo = co_commaSeparated(data.moSiyoryoLow) + '～' + co_commaSeparated(data.moSiyoryoUpr);
			}
			this.disp.elevatorUmu = data.elevatorUmu;
			this.disp.siyouEtc = data.siyouEtc;
			this.disp.jikotaisyo = data.jikotaisyo;
			this.disp.jikonaiyo = data.jikonaiyo;
			this.disp.ymBosyu = data.ymBosyu;
			this.disp.jyutakuKind = data.kbZyutaku;
			this.disp.bosyuKind = this.bosyuKind;
			this.disp.zikoUmu = this.zikoUmu;
			this.disp.nmBosyu = data.nmBosyu;
			this.disp.nmZyutaku = data.nmZyutaku;
			this.disp.mapLink = data.txMapLink == null ? '' : data.txMapLink;

			// 表示項目制御
			if (this.disp.zikoUmu == '1') {
				// 居室内で病死等があった住宅 ※２人以上の家族向のみの場合
				this.disp.listHideKbn = 1;
			} else {
				// 世帯向（一般募集住宅） ※２人以上の家族向のみの場合
				this.disp.listHideKbn = 2;
			}
			
		}

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);

		// 入力値保持
		this.$store.commit(STORE_DATA_ADD_DATA, { id:'BC057', data: this.disp });

		// 世帯情報代理入力へボタン名の取得
		this.disp.bc058BtnName = '世帯情報代理入力へ';

	},
	methods: {

		// 世帯情報代理入力へボタン押下処理
		clickInsertBtn: async function () {

			// エラーをクリア
			this.$store.commit(STORE_ERROR_CLEAR);

			//確認ダイアログ表示
			co_confirmDialog(co_getMessage("W0018"), this.doKariTouroku);
			return;

		},

		// 確認ダイアログ「はい」ボタン押下時処理
		doKariTouroku: async function (flg) {

			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				//共通部品（残戸数チェック、公開終了チェック）の処理を行うControllerを呼び出す
				let checkInfo = {
					'bosyuKind' : this.disp.bosyuKind.substring(0, 2),
					'kbZyutaku' : this.disp.jyutakuKind,
					'ymBosyu' : this.disp.ymBosyu,
					'noMouchiku' : this.disp.noMouchiku,
					'nmBosyu' : this.disp.nmBosyu,
					'nmZyutaku' : this.disp.nmZyutaku
				};
				let checkDate = await co_post(PATH_BC057_CHECK, checkInfo);
				//戻り値判定
				if (checkDate.errorMsgId == 'E0100'){
					//残戸数チェック
					// エラーメッセージ：E0100を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0100'));

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// ページトップへ遷移
					co_toTop();

					return;
				} else if (checkDate.errorMsgId == 'E0105') {
					//公開中チェック
					// エラーメッセージ：E0105を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0105'));
					
					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// ページトップへ遷移
					co_toTop();

					return;
				} else {
					
					this.disp.noRenzoku = checkDate.noRenzoku;

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// 完了ダイアログ表示
					co_completedDialog(co_getMessage('I0032'), this.doClose);
				}
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},

		// 完了ダイアログ「はい」ボタン押下時処理
		doClose: function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// this.disp.nuZankosu = this.disp.nuZankosu - 1;

				// 世帯情報代理入力画面へ遷移
				let params = {
								transKbn: '1',
								jyutakuInfo: this.disp,
								noRenzoku: this.disp.noRenzoku
							};
				co_toTrans('BC058', params);
			}
		},

		// 戻るボタン押下処理
		goBackBtn: function () {
			// 募集住宅一覧（随時募集・管理者用【代理申込み】）画面へ遷移
			co_toTrans('BC056');
		},

		// 地図等の詳細情報へボタン押下処理
		moveMapSite: function () {
			// 外部マップサービスのリンクへ遷移
			window.open(this.disp.mapLink, '_blank')
		}
	}
}
</script>
<style scoped>
.div-tyuimargin {
	margin-left: 2%;
	margin-right: 2%;
	margin-bottom: 2%;
}

@media screen and (min-width: 768px) {

	#pc_text {
		display: inline-block;
		text-align: left;
		margin-top: 3px;
	}
	.detail_btn {
		margin-bottom: 2%
	}
	.cancel_btn {
		margin-left: 1%
	}

	.text-lineheight {
		line-height: 1.7em;
	}

	.contents__btn--map {
		background:yellowgreen;
		color: #000000;
		border-radius: 25px !important;
		font-weight: normal;
		display: inline-block;
		width: auto;
		border: none;
		padding: 0.3em 1.1em;
		margin-top: 5px;
		position: relative;
		font-size: 16px;
		cursor: pointer;
	}

	.contents__btn--map:hover {
		background: green;
		color: #ffffff;
	}

	.margin-map_btn {
		margin-left: 8px;
	}
}
</style>
